import { render } from "./Resume.vue?vue&type=template&id=6874b8a4&ts=true&lang=pug"
import script from "./Resume.vue?vue&type=script&lang=ts"
export * from "./Resume.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ferca/Projects/ferca.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__